import type { FaireProductEntity } from "../../entity_types/product";

export const p_egnnzqszi6: FaireProductEntity = {
  token: "p_egnnzqszi6",
  type: "product",
  name: "Gold Virgin Mary Necklace, Religious Necklace, Medium",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/a1cf463c052eeb0e9f581035e18264f486ec9fd298fae52cb71f80e4bffed3c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58847642f0c9d6e5449c6b842aa818c4f0436e8a2b3b61b39eb5300d1085960b.jpeg",
    "https://cdn.faire.com/fastly/3bdfab8f76adde09d6d3c101c6f7cba8391566a88e46032ba3402a72cc82d0fe.jpeg",
    "https://cdn.faire.com/fastly/839505e6c2968dd2fc1b7ccd04d7e0e487a36b4b770f57f02e7ae3d0a022973e.jpeg",
    "https://cdn.faire.com/fastly/81e64a356844cb84e8822e9d24156a9f3015fed2804863e8d4bd95c586cb25be.jpeg",
    "https://cdn.faire.com/fastly/765f682dd0a22d0a2d9a8a963b4b49a0ac343251893c68f60e277ca246c216b1.jpeg",
  ],
  priceDollars: 13,
  description:
    "Virgin Mary pendant necklace measuring 11x15mm on a 14k gold filled chain. Medium size.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:43.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
